import { Component } from '@angular/core';

@Component({
  selector: 'cv-admin-awards',
  templateUrl: './cv-admin-awards.component.html',
  styleUrls: ['./cv-admin-awards.component.scss']
})
export class CvAdminAwardsComponent {

}
